import ModalCustom from "components/ModalCustom"
import ActionFooterModalCard from "components/ModalCustom/ActionFooterModalCard"
import { useEffect, useState } from "react"
import { closeModal, openModal } from "reducers/modal"
import { configureStore } from "stores/configureStore"
import FormInputCard from "pages/auth/molecules/FormInputCard"
import SelectMulti from "components/Select/SelectMulti"
import { GroupsOrganizationResponse } from "pages/groups/groups.type"
import NoDataCard from "pages/project-build/molecules/NoDataCard"
import { postAssignProjectToGroupsOrganizationMiddleware } from "pages/groups/groups.api"
import { closeLoading, startLoading } from "reducers/loading"
import {
  addRoleGroupOrganizationMiddleware,
  handleUserShareKeyProjectMiddleware,
} from "../services/api"
import LabelNotificationPage from "components/Notification/LabelNotificationPage"
import { toast } from "react-toastify"
import { postActionLogMiddleware } from "components/activity-log/activity-log.api"
import { encryptionController } from "controllers/EncryptionController"
import { ActivityLogType, activityLogHelper } from "helpers/activity_log"
import { getUserId } from "helpers/local_storage"

interface AssignToGroupModalProps {
  isOpen: boolean
  groups: GroupsOrganizationResponse[]
  onClose: () => void
  projectId: string
  callback: () => void
  projectDecrypted: string
}

export const AssignToGroupModal = (props: AssignToGroupModalProps) => {
  const { onClose, projectId, groups, callback, isOpen, projectDecrypted } =
    props

  const [selectedOrganization, setSelectedOrganization] = useState<
    {
      label: string
      value: string
    }[]
  >([])

  useEffect(() => {
    if (!isOpen) {
      return
    }
    setSelectedOrganization([])
  }, [isOpen])

  const onSubmit = () => {
    configureStore.dispatch(
      openModal({
        type: "Delete",
        props: {
          deleteModal: {
            title: (
              <p>
                Adding this project to a group will update its associations
                immediately.
              </p>
            ),
            label: `Warning`,
            content: `This action cannot be undone.`,
            onSubmit: async () => {
              try {
                configureStore.dispatch(startLoading())
                for (const el of selectedOrganization) {
                  const content = await encryptionController().encrypt(
                    activityLogHelper.toLogMessage(
                      ActivityLogType.AssignProjectToGroup,
                      {
                        groupName: el.label,
                      }
                    ),
                    {
                      dataType: "string",
                      type: "project",
                      encryptionKey: projectDecrypted,
                    }
                  )
                  try {
                    await postAssignProjectToGroupsOrganizationMiddleware({
                      project_id: projectId,
                      group_organization_id: el.value,
                    })
                    await postActionLogMiddleware(
                      {
                        content: content,
                        created_by: getUserId() || "",
                        model: "projects",
                        relation_id: projectId,
                      },
                      true
                    )
                    await handleUserShareKeyProjectMiddleware(
                      false,
                      true,
                      JSON.stringify([projectId]),
                      el.value
                    )
                    await addRoleGroupOrganizationMiddleware({
                      is_share_all_project: false,
                      project_ids: JSON.stringify([projectId]),
                      group_ids: JSON.stringify([el.value]),
                    })
                  } catch (error) {}
                }
                closeModal()
                onClose()
                closeLoading()
                callback()
                toast(
                  <LabelNotificationPage
                    messenger="Add project to group successfully!"
                    type="success"
                  />
                )
              } catch (error: any) {
                closeModal()
                closeLoading()
                toast(
                  <LabelNotificationPage
                    messenger="Add project to group failed!"
                    type="error"
                  />
                )
              }
            },
            styleTitle: { textAlign: "center" },
            titleButton: "Continue",
            colorYellowButton: true,
          },
        },
      })
    )
  }

  return (
    <ModalCustom
      label="Add group"
      widthModal={500}
      handleChangeButton={() => onClose}
      bodyChildren={
        <div className="flex flex-col">
          {groups.length ? (
            <>
              <div className="grid grid-cols-1 gap-2 mb-[24px]">
                <FormInputCard title="Groups" fontWeightText="font-semibold">
                  <SelectMulti
                    options={groups.map((el) => ({
                      label: `${el.code} - ${el.name}`,
                      value: el.id,
                    }))}
                    selectedOption={selectedOrganization}
                    handleChange={setSelectedOrganization}
                    noOptionsMessage
                  />
                </FormInputCard>
              </div>
              <ActionFooterModalCard
                onCloseModal={onClose}
                onSubmit={onSubmit}
                handleDisableButton={!selectedOrganization.length}
                titleButton="Add"
              />
            </>
          ) : (
            <NoDataCard label="No groups found" />
          )}
        </div>
      }
    />
  )
}
